import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ShareClass } from '../../types/share-classes.types';
import { useAppQuery } from '../use-app-query.hook';

export type ModifiedShareClass = {
  conversionRatio: number;
  id: string;
  shareClass: ShareClass;
};

export const useModifiedShareClasses = ({ scenarioId }: { scenarioId: string }) => {
  const queryClient = useQueryClient();
  const { data: modifiedShareClasses, isLoading } = useAppQuery<ModifiedShareClass[]>({
    queryKey: [QueryKey.GET_MODIFIED_SHARE_CLASSES, scenarioId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId, 'modified-share-classes'],
      }),
    enabled: !!scenarioId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_MODIFIED_SHARE_CLASSES] });
  }, [queryClient]);

  return {
    invalidateQuery,
    modifiedShareClasses,
    isLoading,
  };
};
